/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateNoteTemplateRequestFromJSON(json) {
    return StreemApiUpdateNoteTemplateRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateNoteTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !exists(json, 'title') ? undefined : json['title'],
        'authorSid': !exists(json, 'author_sid') ? undefined : json['author_sid'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}
export function StreemApiUpdateNoteTemplateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'author_sid': value.authorSid,
        'text': value.text,
    };
}
//# sourceMappingURL=StreemApiUpdateNoteTemplateRequest.js.map